import { getResponse, ProductCondition } from './product-condition';


export interface ProductConditionResponseAttributes {
  product_condition_id: number;
  response: string | boolean | null;
}

export class ProductConditionRequest {
  conditions: ProductConditionResponseAttributes[];

  constructor(productConditions?: ProductCondition[]) {
    if ((productConditions?.length ?? -1) > 0) {
      this.conditions = this.formatProductConditions(productConditions!);
    } else {
      this.conditions = [];
    }
  }

  private formatProductConditions(productConditions: ProductCondition[]): ProductConditionResponseAttributes[] {
    return productConditions
      .filter(productCondition => getResponse(productCondition) !== null)
      .map(productCondition => ({
        product_condition_id: productCondition.id,
        response: getResponse(productCondition) ?? null
      }));
  }
}

